import React from "react";
import { useI18nMessage } from "@lookiero/i18n-react";
import { DOMAIN, I18nMessages, PREFIX } from "../../../i18n/i18n";
import { ActionButton } from "../actionButton/ActionButton";
const Like = ({ status, onPress }) => {
    const likeText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.LIKE, prefix: PREFIX });
    return (React.createElement(ActionButton, { alignment: "right", icon: "heart", status: status, testID: "like-button", text: likeText, onPress: onPress }));
};
export { Like };
